<template>
  <div
    class="row no-margin flexed-column-wrapper-fixed-side"
    style="overflow-x: hidden;"
  >
    <div
      class="rest-of-height side-nav-slot overflow-y"
      :style="{
        maxWidth: size_of_side_nav,
        backgroundColor: nav_background_color,
      }"
    >
      <slot name="side-nav-slot" />
    </div>
    <div
      :id="bodyID"
      style="position: relative; overflow-x: hidden;"
      class="fixed-sidebar-body col-xs rest-of-height no-padding"
    >
      <slot name="side-body-slot" />
    </div>
  </div>
</template>

<script>
  import './fixedSideBar.styl';

  export default {
    data() {
      return {};
    },
    computed: {
      size_of_side_nav() {
        if (this.sizeOfFixedSideInPixels !== -1) {
          return `${this.sizeOfFixedSideInPixels}px`;
        }
        if (this.sizeOfFixedSideInPercent !== -1) {
          return `${this.sizeOfFixedSideInPercent}%`;
        }
        return '200px';
      },
      nav_background_color() {
        return this.navBackgroundColor;
      },
    },
    props: {
      navBackgroundColor: {
        type: String,
        default: '#f0f0f0',
      },
      sizeOfFixedSideInPercent: {
        type: Number,
        default: -1,
      },
      sizeOfFixedSideInPixels: {
        type: Number,
        default: -1,
      },
      bodyID: {
        type: String,
        default: null,
      },
    },
    components: {},
    methods: {},
  };
</script>

<style lang="stylus" scoped>
  .rest-of-height
    &&::-webkit-scrollbar {
      display: unset !important;
      position: absolute;
      top: 20px;
      right: 20px;
      margin: 0px;
      width: unset !important;
    }
</style>



// WEBPACK FOOTER //
// fixedSideBar.vue?0d75d673